export default "__VITE_ASSET__CNmyS5M2__"